import React from "react";

// NavUnreadPill — the D26 global chat-unread badge shown on the "Messages"/Inbox
// nav item. Renders nothing at zero; caps at 99+. Uses the canonical unread
// badge tokens (bg #2283FF, white, 10.5px/700) shared with the inbox tab counts.
const NavUnreadPill = ({ count = 0, className = "" }) => {
  if (!count || count <= 0) return null;
  const label = count > 99 ? "99+" : String(count);
  return (
    <span
      className={
        "inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-[#2283FF] px-[5px] text-[10.5px] font-bold text-white " +
        className
      }
      aria-label={`${label} unread messages`}
    >
      {label}
    </span>
  );
};

export default NavUnreadPill;
